import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["indicator ma-2", 'state-'+(_ctx.state ? _ctx.state : 'neutral')]),
    style: _normalizeStyle('background-color:'+ _ctx.color+';')
  }, null, 6))
}